import { render, staticRenderFns } from "./SessionExpiredDialog.vue?vue&type=template&id=5cbb6d22&"
import script from "./SessionExpiredDialog.vue?vue&type=script&lang=js&"
export * from "./SessionExpiredDialog.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/components/dialogs/session-expired-dialog.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports